// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../isLastDayOfMonth/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var isLastDayOfMonth = convertToFP(fn, 1);
export default isLastDayOfMonth;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/isLastDayOfMonth/index.js
// module id = 926
// module chunks = 0